import { Component, OnInit, ViewChild } from '@angular/core';
import { Navigator } from '../../../components/menu/navigator';
import { BonusContent } from '../../../popovers/bonus-content/bonus-content.page';
import { AccountBalanceService } from '../../../services/balance/account-balance.service';
import { NavOverriderService } from 'src/app/services/navOverrider/nav-overrider.service';
import { PopoverController } from '@ionic/angular';
import { EventsService } from 'src/app/services/event/event.service';
import { CollectButtonComponent } from '../../buttons/collect-button/collect-button.component';
import { ConfigService } from 'src/app/services/config/config.service';
import { BonusService } from 'src/app/services/bonus/bonus.service';
import { UtilsService } from 'src/app/services/utils/utils.service';

@Component({
  selector: 'app-bonus-collection',
  templateUrl: './bonus-collection.component.html',
  styleUrls: ['./bonus-collection.component.scss'],
})
export class BonusCollectionComponent implements OnInit {
  @ViewChild(CollectButtonComponent) childComponent: CollectButtonComponent;

  public campaignData: CampaignData;
  private autoHideCount: number = 6000;  
  private activePopover;
  private hasRedeemed: boolean = false; // Added flag

  constructor(
    private navigator: Navigator,
    private navOverride: NavOverriderService,
    private popOverCtrl: PopoverController,
    private eventService: EventsService,
    private balanceProvider: AccountBalanceService,
    private config: ConfigService,
    private bonusService: BonusService,
    private utils: UtilsService
  ) {
    this.activePopover = this.navigator?.activePopovers[this.navigator.activePopovers.length - 1];
    this.campaignData = this.activePopover?.componentProps?.data;

    this.eventService.subscribe("event:authentication:logout", () => {
      this.closePopover();
    });

    const closeTimer = this.config.getConfig().BONUS_POPOVER_AUTO_CLOSE_TIMER || 15000;
    setTimeout(() => {
      this.onBannerClick();
    }, closeTimer);
  }

  ngOnInit() {}

  onBannerClick() {
      if (this.hasRedeemed) return;

      this.hasRedeemed = true;
      this.bonusService.callRedeemBonus(this.campaignData.campaign_code).subscribe(
      (response: any) => {
        if (response && !!response.result) {          
          this.balanceProvider.updateBalance();
          this.triggerCoinFlying();
          setTimeout(() => {
            this.closePopover();

            setTimeout(() => {
              let coins = this.campaignData.offer_amount;
              this.openCoinDeliveredPopover(coins);  
            }, 500);
          }, 1000);
        }
      },
      (error) => {
        switch (error.getErrorCode().toUpperCase()) {
          case 'WRONG_BONUS_CODE':
            console.log('The bonus code is wrong or expired, please try another one.');
            break;
        }
        this.closePopover();
      }
    );
  }

  triggerCoinFlying() {
    this.childComponent.handleButtonClickFromParent();
  }

  private openCoinDeliveredPopover(coins) {
    const data: BonusContent = {
      isAutoHideEnabled: true,
      isAutoHideTimeout: this.autoHideCount,
      amount: coins,
      istopLeft: true,
      title: "YOU HAVE CLAIMED"
    }

    this.navigator.openPopover('BonusContentPage', data, "auto-dismiss-popover", true, true, true, -1, 'cover', false);
  }

  closePopover() {
    this.navOverride.setCustomCloseFunction(undefined);
  
    if (this.activePopover) {
      this.activePopover.dismiss().catch((err) => {
        // Fallback to PopoverController
        this.popOverCtrl.dismiss().catch((dismissErr) => {
          console.error('Error dismissing with PopoverController:', dismissErr);
        });
      });
    } else {
      // If activePopover is undefined, use PopoverController
      this.popOverCtrl.dismiss().catch((err) => {
        console.error('Error dismissing with PopoverController:', err);
      });
    }
    this.navigator.dismissPopover();
  }
  
}

export interface CampaignData {
  id: string;
  description: string;
  banner_image_small: string;
  banner_image_medium: string;
  banner_image_large: string;
  campaign_type: string;
  campaign_code: string;
  campaign_category: string;
  bg_path: string;
  show_banner_flag: string;
  show_thumbnail_flag: string;
  offer_type: string;
  offer_amount: string;
  display_name: string;
}
